<div class="me-dynamic-report-onboarding" *ngIf="data">
    <div class="container">
        <div class="me-dynamic-report-onboarding--card" *ngIf="!activeCluster">
            <i class="me-dynamic-report-onboarding--card--close-btn btn fal fa-times" (click)="goBack()"></i>
            <div class="row me-dynamic-report-onboarding--card--body">
                <div tabindex="0" class="col-xs-12 col-sm-6">
                    <div class="row me-dynamic-report-onboarding--card--body--header">
                        {{data.headline}}
                    </div>
                    <div class="row me-dynamic-report-onboarding--card--body--text"
                         [innerHTML]="data.text | storyblokRichtext"></div>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <dynamic-report-bubble-chart [data]="clusters" [class]="'tutorial'"></dynamic-report-bubble-chart>
                </div>
                <div class="col-xs-12 text-right" (click)="next()">
                    <button class="btn btn--primary btn--next">{{ 'Next' | translate}}</button>
                </div>
            </div>
        </div>

        <div class="me-dynamic-report-onboarding--card" *ngIf="activeCluster">
            <div class="me-dynamic-report-onboarding--card--cluster">
                <svg viewBox="0 0 200 250">
                    <path d="M103.062 0.0355682C136.48 0.891831 166.95 19.6264 185.927 47.1468C203.401 72.4874 201.966 104.237 195.696 134.373C189.218 165.506 180.168 200.056 151.327 213.452C122.763 226.719 90.9367 210.909 63.2575 195.885C37.7517 182.04 15.8324 162.805 7.05921 135.142C-2.76828 104.154 -4.13501 69.2593 14.6952 42.7593C34.6336 14.6997 68.6512 -0.846135 103.062 0.0355682Z"
                        attr.fill="{{color}}"></path>
                    <path _ngcontent-abi-c228=""
                          d="M96.7845 0.00817202C130.091 -0.438468 161.026 17.4617 180.84 44.2378C199.8 69.8604 204.45 103.188 195.847 133.88C187.751 162.767 165.425 184.687 138.04 196.938C111.682 208.729 81.6945 209.155 55.7049 196.572C29.783 184.023 12.0132 160.138 4.56413 132.318C-3.28737 102.995 -1.84841 71.3584 15.5094 46.4549C34.2814 19.5223 63.9584 0.448364 96.7845 0.00817202Z"
                          attr.fill="{{color}}"></path>
                    <path _ngcontent-abi-c228=""
                          d="M94.6183 0.00657983C125.826 0.50088 145.075 30.8299 164.202 55.4944C182.841 79.5297 204.484 104.902 199.188 134.853C193.665 166.088 166.904 187.981 138.338 201.77C109.734 215.576 76.3067 222.198 47.9747 207.842C20.1852 193.761 6.35647 163.029 1.23606 132.299C-3.47842 104.006 5.67337 76.6792 22.2146 53.2455C40.3901 27.4967 63.1049 -0.492561 94.6183 0.00657983Z"
                          attr.fill="{{color}}"></path>
                </svg>
            </div>
            <i class="me-dynamic-report-onboarding--card--close-btn btn fal fa-times" (click)="goBack()"></i>
            <div class="row me-dynamic-report-onboarding--card--body">
                <div tabindex="0" class="col-xs-12 col-sm-6 me-dynamic-report-onboarding--card--body--overview">
                    <div class="row me-dynamic-report-onboarding--card--body--header">
                        {{activeCluster.name}}
                    </div>
                    <div class="row me-dynamic-report-onboarding--card--body--text"
                         [innerHTML]="activeCluster.onBoardingText | storyblokRichtext"></div>
                </div>
                <div class="col-xs-12 col-sm-6 row me-dynamic-report-onboarding--card--body--image">
                    <img [src]="activeCluster.image.filename"/>
                </div>
                <div class="col-xs-12 col-sm-6 me-dynamic-report-onboarding--card--body--percent">
                    <span class="col-xs-6 me-dynamic-report-onboarding--card--body--percent--text">{{percent}}%</span>
                    <round-progress
                            [current]="percent"
                            [max]="100"
                            [color]="color"
                            [background]="'#eaeaea'"
                            [radius]="28"
                            [stroke]="5"
                            [rounded]="true"
                            [clockwise]="true"
                            [responsive]="false">
                    </round-progress>
                    <span>{{ 'Frequency among our users' | translate}}</span>
                </div>
                <div class="col-xs-12 text-right me-dynamic-report-onboarding--card--body--btn" (click)="next()">
                    <button class="btn btn--primary btn--next">{{ 'Next' | translate}}</button>
                </div>
            </div>
        </div>
    </div>

</div>